import React from 'react';

import StyledMuiDividerComponent from './styled-components/StyledMuiDividerComponent';

const Divider = () => {
  return <StyledMuiDividerComponent role="presentation" />;
};

export default Divider;
